import styled from "@emotion/styled";
import { ModalProps } from "./Modal";

export const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
`;

export const Overlay = styled.div`
  position: fixed;
  background: rgba(0, 0, 0, 0.6);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
`;

export const Content = styled.div<Partial<ModalProps>>`
  z-index: 10;
  position: relative;
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 10px 10px 0 5px;

  position: fixed;
  background: white;
  width: calc(100% - 24px);
  max-width: ${({ width }) => (width ? width : "780px")};
  height: auto;
  top: 50%;
  left: 50%;
  border-radius: 16px;
  transform: translate(-50%, -50%);
  padding: 24px;
`;

export const CloseButton = styled.button`
  position: absolute;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  right: 20px;
  top: 15px;
  font-size: 15px;
  border: none;
`;
